import { FAILURE_PRODUCT, GET_PRODUCT, REQUEST_PRODUCT } from "./productActionType"
import axios from "axios"




export const getProducts = (baseUrl,ParamObj="")=>(dispatch) =>{

    dispatch({ type: REQUEST_PRODUCT })

    return axios.get(`${baseUrl}`,ParamObj).then((res) => {
        console.log("get products work", res)
        console.log(res.headers["x-total-count"])
      dispatch({ type: GET_PRODUCT, payload: res.data })
    }).catch((err) => {
        return dispatch({ type: FAILURE_PRODUCT })
    })
}